// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"672c1e60","239":"707e7c97","453":"3f20db29","455":"5e0d6b49"}[chunkId] + ".chunk.js";
};